<template>
  <div class="boxContent">
    <div class="setUser-table">
      <div
        :class="{
          'setUser-tap-left': true,
          'setUser-overall': actived === 0,
          'setUser-Single': !(actived === 0),
        }"
        @click="changeListShow(0)"
      >
        会话查看
      </div>
      <div
        :class="{
          'setUser-tap-right': true,
          'setUser-overall': actived === 1,
          'setUser-Single': !(actived === 1),
        }"
        @click="changeListShow(1)"
      >
        会话检索
      </div>
      <div
        :class="{
          'setUser-tap-right': true,
          'setUser-overall': actived === 2,
          'setUser-Single': !(actived === 2),
        }"
        @click="changeListShow(2)"
      >
        敏感词
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ReleaseManagement',
  components: {},
  data() {
    return {
      actived: 0 /* 头部切换栏选中项 */,
    };
  },
  created() {
    if (this.$route.query.actived) {
      console.log(this.$route.query.actived);
      this.actived = Number(this.$route.query.actived);
    }
  },
  methods: {
    changeListShow(type) {
      if (type === 1) {
        this.g_tourl(`/saas/chattingRecords/conversationView.html?actived=${type}`, {
          open: false,
        });
      } else if (type === 2) {
        this.g_tourl(`/saas/chattingRecords/sensitiveWords.html?actived=${type}`, {
          open: false,
        });
      } else {
        this.g_tourl(`/saas/chattingRecords.html`, {
          open: false,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
